import '~/pages/projects/merge_requests/show';
import { initVerificationAlert } from './init_verification_alert';

initVerificationAlert();
